const partnerProductStatuses = ['NEW', 'Approved', 'Review', 'FC Action'];
export default partnerProductStatuses;